import configureStore from './configureStore';

const store = configureStore();

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js